export default (ctx, html) => html`
  <a dom-scope="n398hjf" href="${ctx.href}" @click="${(e) => ctx.clickHandler(e)}" tabindex="${ctx.tabFocusDisabled ? '-1' : '0'}">
    <slot></slot>
  </a>
`;
